export default __webpack_public_path__ + "static/media/product.4944ad63.jpeg";